export const rxrPrimaryColor = '#431A1A'
export const rxrSoftHighlightedPrimary = '#582121'
export const rxrTintColor = '#6E2C2C'
export const rxrTint25Color = '#FFC197'
export const rxrTint15Color = '#FFF0E6'

export const rxrBlackColor = '#000000'
export const rxrDarkGreyColor = '#5E5E5E'
export const rxrMediumGreyColor = '#919191'
export const rxrMediumLightGreyColor = '#b0b0b0'
export const rxrGreyColor = '#E0E0E0'
export const rxrLightGreyColor = '#F0F0F0'
export const nearWhiteColor = '#F8F8F8'
export const rxrWhiteColor = '#FFFFFF'

export const textColor = '#454545'

export const rxrRedColor = '#E02020'
export const rxrGreenColor = '#009A02'
export const rxrSuccessColor = '#6ED16F'
export const rxrSuccess25Color = 'rgba(110, 209, 111, 0.25)'
export const rxrYellowColor = '#F9BA30'
export const rxrLightYellowColor = 'rgba(249, 186, 48, 0.15)'
export const rxrOrangeColor = '#ff9901'
export const rxrStatusGreenColor = '#009A02'
export const rxrMonotoneLightGreyColor = '#D8D8D8'
export const rxrContainerColor = '#F5F5F5'
export const rxrWarmBrown = '#C09891'
export const rxrErrorColor = '#FE4E5E'
export const rxrErrorColorLight = '#FF8D98FF'
export const rxrMidPrimary = rxrTint25Color
export const rxrSecondaryPrimaryGrayColor = '#c6b0a3'
export const rxrTintDarkColor = '#d48760'
export const rxrBlackDarkerColor = '#351313'
export const rxrLightTint = '#ffdac2'
export const rxrSidePanelBackgroundCoor = '#FCFAFA'
export const whiteOverlay50 = 'rgba(255,255,255,0.5)'
export const blackOverlay50 = 'rgba(0,0,0,0.5)'
export const blackOverlay80 = 'rgba(0,0,0,0.8)'

export const messageBubbleColor = rxrGreyColor
export const messageBubbleColorMine = rxrTint25Color
export const messageBubbleColorPeer = rxrLightTint
export const magenta = '#DB76FF'

export const magentaLight = '#e9b6ff'

export const pink = '#e867c3'
export const purple = '#7300E6'
export const lavender = '#C176FF'

// Monotone color

export const black = {
  color: rxrBlackColor,
}

export const darkGrey = {
  color: rxrDarkGreyColor,
}

export const backgroundLightGrey = {
  backgroundColor: rxrLightGreyColor,
}

export const shadowSoft = '0px 4px 20px 4px rgba(0, 0, 0, 0.05)'

export const shadowHard = '0px 4px 10px 0px rgba(0, 0, 0, 0.1)'
